export interface ApiResponse {
    payload: {
        html: string;
    };
}

export const fetchData = async (
    endpoint: string,
    locale: string
): Promise<string> => {
    let data: ApiResponse | null = null;
    if (endpoint) {
        // Append locale to the endpoint if it is not already present
        const url = new URL(endpoint);
        if (!url.searchParams.has("locale")) {
            url.searchParams.append("locale", locale.replace("-", "_"));
        }
        try {
            const response = await fetch(url);
            if (response.ok) {
                data = await response.json();
            } else {
                console.error(`Failed to fetch data from ${endpoint}`);
                return "";
            }
        } catch (error) {
            console.error(`Error fetching data from ${endpoint}:`, error);
            return "";
        }
    }
    if (data.payload?.html) {
        const el = document.createElement("div");
        el.innerHTML = data.payload.html;
        const navElement = el.querySelector("nav");
        return navElement.innerHTML;
    }
    console.warn("No valid HTML payload found in the response.");
    return "";
};
